import React, { useEffect, useState } from "react";

const API_BASE = process.env.REACT_APP_API_URL; // e.g. http://localhost:8000/api

const DashboardTab = ({ farmerUsername, fromDate, toDate }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!farmerUsername) {
      setError("Farmer username is required");
      setLoading(false);
      return;
    }

    const payload = { username: farmerUsername };
    if (fromDate && toDate) {
      payload.fromDate = fromDate;
      payload.toDate = toDate;
    }

    fetch(`${API_BASE}/dashboard-summary`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(payload),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.status === "success") {
          setData(result.data);
        } else {
          setError("Failed to fetch dashboard data");
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching dashboard:", err);
        setError("Error loading dashboard");
        setLoading(false);
      });
  }, [farmerUsername, fromDate, toDate]);

  if (loading) return <div style={{ padding: "10px" }}>Loading...</div>;
  if (error) return <div style={{ padding: "10px", color: "red" }}>{error}</div>;
  if (!data) return <div style={{ padding: "10px" }}>No data available</div>;

  const { cow, buffalo, expenses } = data;
  console.log("Dashboard Data:", data);
  console.assert(cow && buffalo && expenses, "Incomplete dashboard data");
  console.log("Expenses Data:", expenses);
  
  const totalLiters = parseFloat(cow.qty || 0) + parseFloat(buffalo.qty || 0);
  const totalAmount = parseFloat(cow.amount || 0) + parseFloat(buffalo.amount || 0);

  const formatCurrency = (value) =>
    `₹${Number(value || 0).toLocaleString("en-IN", { minimumFractionDigits: 2 })}`;

  return (
    <div style={{ padding: "10px", fontFamily: "sans-serif" }}>
      <h3 style={{ marginBottom: "20px", color: "#1B5E20" }}>डॅशबोर्ड (बिल रेकॉर्ड वर आधारित)</h3>
      {/* Section: संकलन */}
      <div
        style={{
          border: "2px solid #4CAF50",
          borderRadius: "8px",
          padding: "10px",
          marginBottom: "15px",
        }}
      >
        <h2 style={{ marginBottom: "10px", color: "#2E7D32" }}>संकलन</h2>

        {/* Cow Card */}
        <div style={cardStyle}>
          <Row label="गाय Qty" value={parseFloat(cow.qty).toFixed(1)} />          
          <Row label="Fat %" value={parseFloat(cow.fat).toFixed(1)} />
          <Row label="SNF %" value={parseFloat(cow.snf).toFixed(1)} />
          <Row label="दर" value={parseFloat(cow.rate).toFixed(2)} />  
          <Row label="रक्कम" value={formatCurrency(cow.amount)} bold />
        </div>

        {/* Buffalo Card */}
        <div style={cardStyle}>
          <Row label="म्हैस Qty" value={parseFloat(buffalo.qty).toFixed(1)} />
          <Row label="Fat %" value={parseFloat(buffalo.fat).toFixed(1)} />
          <Row label="SNF %" value={parseFloat(buffalo.snf).toFixed(1)} />
          <Row label="दर" value={parseFloat(buffalo.rate).toFixed(2)} />
          <Row label="रक्कम" value={formatCurrency(buffalo.amount)} bold />
        </div>

        {/* Total Row */}
        <div
          style={{
            ...cardStyle,
            backgroundColor: "rgba(191, 239, 195, 1)",
          }}
        >
          <Row label="एकूण लिटर्स" value={parseFloat(totalLiters).toFixed(2)} bold />
          <Row label="एकूण रक्कम" value={formatCurrency(totalAmount)} bold />
        </div>
      </div>

      {/* Section: खर्च व देणी बाकी */}
      <div
        style={{
          border: "2px solid #4CAF50",
          borderRadius: "8px",
          padding: "10px",
        }}
      >
        <h2 style={{ marginBottom: "10px", color: "#2E7D32" }}>खर्च व देणी</h2>

        {/* Aushadhe/Medicines */}
        <div style={cardStyle}>
          <Row
            label="खर्च (औषधे)"
            value={formatCurrency(expenses.aushadhe?.expense)}
          />
          <Row
            label="देणे बाकी (औषधे)"
            value={formatCurrency(expenses.aushadhe?.debt)}
          />
        </div>

        {/* AI Charges */}
        <div style={cardStyle}>
          <Row
            label="खर्च (A.I.)"
            value={formatCurrency(expenses.AICharges?.expense)}
          />
          <Row
            label="देणे बाकी (A.I.)"
            value={formatCurrency(expenses.AICharges?.debt)}
          />
        </div>

        {/* Feed */}
        <div style={cardStyle}>
          <Row
            label="खर्च (खाद्य)"
            value={formatCurrency(expenses.feed?.expense)}
          />
          <Row
            label="देणे बाकी (खाद्य)"
            value={formatCurrency(expenses.feed?.debt)}
          />
        </div>

        {/* Advance */}
        <div style={cardStyle}>
          <Row
            label="खर्च (अडवांस)"
            value={formatCurrency(expenses.advance?.expense)}
          />
          <Row
            label="देणे बाकी (अडवांस)"
            value={formatCurrency(expenses.advance?.debt)}
          />
        </div>


        {/* Dudh / Products Vikri */}
        <div style={cardStyle}>
          <Row
            label="खर्च (दूध / उत्पादन विक्री)"
            value={formatCurrency(expenses.othersale?.expense)}
          />
          <Row
            label="देणे बाकी (दूध / उत्पादन विक्री)"
            value={formatCurrency(expenses.othersale?.debt)}
          />
        </div>

        {/* Total */}
        <div
          style={{
            ...cardStyle,
            backgroundColor: "rgba(117, 202, 255, 0.44)",
          }}
        >
          <Row
            label="एकूण खर्च"
            value={formatCurrency(expenses.total?.expense)}
            bold
          />
          <Row
            label="एकूण देणे बाकी"
            value={formatCurrency(expenses.total?.debt)}
            bold
          />
        </div>
        {/* Section: निव्वळ उत्पन्न */}
        <div
          style={{
            border: "2px solid #4CAF50",
            borderRadius: "8px",
            padding: "10px",
            marginTop: "15px",
            backgroundColor: "rgba(255, 243, 205, 0.9)",
          }}
        >
          <h2 style={{ marginBottom: "10px", color: "#2E7D32" }}>निव्वळ</h2>

          <div style={cardStyle}>
            <Row label="एकूण उत्पन्न" value={formatCurrency(totalAmount)} bold />
            <Row
              label="एकूण खर्च"
              value={formatCurrency(expenses.total?.expense)}
              bold
            />

            {/* Net Income */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                fontWeight: "bold",
                padding: "4px 0",
                borderTop: "2px solid #aaa",
                color:
                  totalAmount - parseFloat(expenses.total?.expense || 0) >= 0
                    ? "blue"
                    : "red",
              }}
            >
              <span>निव्वळ (उत्पन्न - खर्च)</span>
              <span>
                {formatCurrency(
                  totalAmount - parseFloat(expenses.total?.expense || 0)
                )}
              </span>
            </div>
          </div>
        </div>
    
      </div>
    </div>
  );
};

// Card style
const cardStyle = {
  border: "1px solid rgba(66, 65, 65, 1)",
  backgroundColor: "rgba(241, 255, 184, 0.77)",
  borderRadius: "10px",
  padding: "8px 10px",
  marginBottom: "15px",
  boxShadow: "rgba(27, 20, 20, 0.99) 3px 7px 6px",
};

// Row component
const Row = ({ label, value, bold }) => (
  <div
    style={{
      display: "flex",
      justifyContent: "space-between",
      fontWeight: bold ? "bold" : "normal",
      padding: "2px 0",
      borderBottom: "1px solid #eee",
    }}
  >
    <span>{label}</span>
    <span>{value}</span>
  </div>
);

export default DashboardTab;
